import { navigate } from "gatsby-link";
import React, { MouseEvent } from "react";
import { gsap } from "gsap";
import { useLocation } from "@reach/router";

interface Props {
  to: string;
  className?: string;
}

export const handlePageLoaded = () => {
  const el = document.getElementById("trans-layer");
  if (!!el) {
    el.style.setProperty("transform-origin", "bottom left");
    gsap.to(el, {
      opacity: 0,
      duration: 0.3,
      ease: "power2.in",
      delay: 0,
    });
  }
}

export const TransLink: React.FC<Props> = (props) => {
  const location = useLocation();
  
  const handleClick = (e: MouseEvent) => {
    e.preventDefault();

    if (location.pathname === props.to) {
      return false;
    }

    const bodyPosition = window.getComputedStyle(document.body).position;

    const el = document.getElementById("trans-layer");
    if (!!el) {
      el.style.setProperty("transform-origin", "top left");
      gsap.to(el, {
        opacity: 1,
        duration: bodyPosition === 'fixed' ? 0 : 0.4,
        ease: "power2.out",
        onComplete: () => {
          navigate(props.to);
          el.style.setProperty("transform-origin", "bottom left");
        },
      });
    } else {
      navigate(props.to);
    }
  };

  return (
    <a href={props.to} className={props.className} onClick={handleClick}>
      {props.children}
    </a>
  );
};
